import inMemoryJwt from "../auth/inMemoryJwt";
import swal from 'sweetalert2'
import { urlServer } from "../config/GlobalConstant";
import {
    GET_POINTS_BY_OIL_DELIVERY, IS_LOADING_POINTS_BY_OIL_DELIVERY,
    POST_RECORD_DELIVERY, IS_LOADING_POST_REGISTER, ERROR_POST_RECORD_DELIVERY,
    GET_POST_TOTAL_RECEIVED, IS_LOADING_GET_ALL_RECEIVED_OIL, GET_ALL_RECEIVED_OIL,
    IS_LOADING_GET_POST_CONSOLIDATE_OIL_DELIVERING, GET_POST_CONSOLIDATE_OIL_DELIVERING,
    IS_LOADING_GET_OIL_RECEIVED_BY_ECOIDEAS, GET_OIL_RECEIVED_BY_ECOIDEAS,
    IS_LOADING_GET_POST_HISTORICAL_OIL_DELIVERING, GET_POST_HISTORICAL_OIL_DELIVERING
} from "./types";

const Toast = swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000
});

export const getPointsByOilDelivery = () => async dispatch => {

    dispatch({ type: IS_LOADING_POINTS_BY_OIL_DELIVERY });

    await fetch(`${urlServer}oilmanagement/points-by-oil`, {
        method: 'GET',
        mode: 'cors',
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJwt.getToken()}`

        }
    })
        .then(response => response.json())
        .then(respJson => {

            if (respJson.success === true) {
                dispatch({
                    type: GET_POINTS_BY_OIL_DELIVERY, payload: respJson.data
                })
            }
        })
        .catch(error => {
            Toast.fire({
                icon: 'error',
                title: 'Error al obtener índice de conversión: litros a ecopuntos, revise su conexión a Internet'
            });
        });
}

export const oilRecordDelivery = (entityEmail, totalLiters, receivingEntityId, history) => async dispatch => {

    dispatch({ type: IS_LOADING_POST_REGISTER });

    await fetch(`${urlServer}oilmanagement/record-delivery`, {
        method: 'POST',
        mode: 'cors',
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
        },
        body: JSON.stringify({
            entityEmail, totalLiters, receivingEntityId
        })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {
                dispatch({
                    type: POST_RECORD_DELIVERY,
                    payload: respJson.data
                })
                Toast.fire({
                    icon: 'success',
                    title: 'Registro exitoso'
                })
                history.push('/OilMenu')
            }
            else {
                dispatch({ type: ERROR_POST_RECORD_DELIVERY });
                if (respJson.error.error.code ==='MSJ011') {
                    Toast.fire({
                        icon: 'error',
                        title: 'El usuario no existe'
                    })
                }
                if (respJson.error.error.code ==='ERR061') {
                    Toast.fire({
                        icon: 'error',
                        title: 'No se puede registrar aceites de una EcoTienda o EcoCeo'
                    })
                }
            }
        })
        .catch(error => {
            Toast.fire({
                icon: 'error',
                title: 'Falló el registro'
            });
        });
}

export const getLitersReceived = (entityId) => async dispatch => {

    await fetch(`${urlServer}historyoilmanagement/get-total-received`, {
        method: 'POST',
        mode: 'cors',
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
        }
        ,
        body: JSON.stringify({
            entityId
        })
    })
        .then(response => response.json())
        .then(respJson => {

            if (respJson.success === true) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: GET_POST_TOTAL_RECEIVED, payload: respJson.data
                })
            }
        })
        .catch(error => {
            
        })
}

export const getAllReceivedOil = (entityId, entityEmail, skip, limit) => async dispatch => {

    dispatch({ type: IS_LOADING_GET_ALL_RECEIVED_OIL });

    await fetch(`${urlServer}historyoilmanagement/get-receiving-id`, {
        method: 'POST',
        mode: 'cors',
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
        },
        body: JSON.stringify({
            entityId, entityEmail, limit, skip
        })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.data.length > 0) {
                dispatch({
                    type: GET_ALL_RECEIVED_OIL,
                    payload: { data: respJson.data, skip, hasMore: true }
                });
            }
            else {
                dispatch({
                    type: GET_ALL_RECEIVED_OIL,
                    payload: { data: [], skip, hasMore: false }
                })
            }
        })
        
}


export const getConsolidateOilDelivering = (entityId) => async dispatch => {

    dispatch({ type: IS_LOADING_GET_POST_CONSOLIDATE_OIL_DELIVERING });

    await fetch(`${urlServer}oilmanagement/get-delivering-id`, {
        method: 'POST',
        mode: 'cors',
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
        }
        ,
        body: JSON.stringify({
            entityId
        })
    })
        .then(response => response.json())
        .then(respJson => {

            if (respJson.success === true) {
                dispatch({
                    type: GET_POST_CONSOLIDATE_OIL_DELIVERING, payload: respJson.data
                })
            }
        })
        .catch(error => {
            Toast.fire({
                icon: 'error',
                title: 'Error al obtener el total de aceite entregado'
            });
        })
}
export const getOilReceivedByEcoideas = () => async dispatch => {

    dispatch({ type: IS_LOADING_GET_OIL_RECEIVED_BY_ECOIDEAS });

    await fetch(`${urlServer}historyoilmanagement/get-total-consolidated`, {
        method: 'POST',
        mode: 'cors',
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
        }
    })
        .then(response => response.json())
        .then(respJson => {

            if (respJson.success === true) {
                dispatch({
                    type: GET_OIL_RECEIVED_BY_ECOIDEAS, payload: respJson.data
                })
            }
        })
        .catch(error => {
            Toast.fire({
                icon: 'error',
                title: 'Error al obtener el total de aceite recibido por Ecoideas'
            });
        })
}


export const getHistoryOilDelivering = (entityId, limit, skip) => async dispatch => {

    dispatch({ type: IS_LOADING_GET_POST_HISTORICAL_OIL_DELIVERING });

    await fetch(`${urlServer}historyoilmanagement/get-delivering-id`, {
        method: 'POST',
        mode: 'cors',
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
        },
        body: JSON.stringify({
            entityId, limit, skip
        })
    })
        .then(response => response.json())
        .then(respJson => {

            if (respJson.data.length > 0) {
                dispatch({
                    type: GET_POST_HISTORICAL_OIL_DELIVERING,
                    payload: { data: respJson.data, skip, hasMoreHistoricalDelivery: true }
                });
            }

            else {
                dispatch({
                    type: GET_POST_HISTORICAL_OIL_DELIVERING,
                    payload: { data: [], skip, hasMoreHistoricalDelivery: false }
                })
            }
        })
        .catch(error => {
            /* Toast.fire({TodoJulian ver si es necesario
                icon: 'error',
                title: 'Error al obtener el aceite entregado'
            }); */
        })
}
